// @flow
import * as React from "react";

import FETCH from "services/fetch";
import withErrorHandler from "hoc/withErrorHandler";

import Parser from "react-html-parser";

import type { OfferPreview as OfferPreviewType } from "offer-preview";
import type { ContextRouter } from "react-router-dom";

import "./index.scss";

type Props = {
  ...ContextRouter,
  onError: (Object) => void,
};

type State = {
  preview: OfferPreviewType,
};

class OfferPreview extends React.Component<Props, State> {
  state = {
    preview: {},
  };

  componentDidMount() {
    FETCH.get(`offer-previews/${String(this.props.match.params.id)}`)
      .then(({ data }) => {
        this.setState({ preview: data });
      })
      .catch((err) => this.props.onError(err));
  }

  render() {
    return <div className="OfferPreview">{Parser(this.state.preview.template)}</div>;
  }
}

export default withErrorHandler(OfferPreview);
